"use client";

import { useTranslations } from "next-intl";
import React, { useState } from "react";
import { BiSort } from "react-icons/bi";
import MainSidebar from "../MainSidebar";
import useCustomReactHookForm from "@/hooks/use-custom-react-hook-form";
import { sortDefaultValue } from "@/formDefaultValues/form-default-value";
import { sortSchema, TSort } from "@/schema/sortSchema";
import GlobalPageSortSidebar from "./GlobalPageSortSidebar";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const buildSortQuery = (field?: string, order?: string) => {
  if (field === "none") return "";

  switch (field) {
    case "newest":
      return "-createdAt"; // always newest
    case "oldest":
      return "createdAt"; // always oldest
    case "az":
      return order === "desc" ? "-title" : "title";
    case "za":
      return order === "asc" ? "title" : "-title";
    default:
      return "";
  }
};

const GlobalPageSort = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const { handleSubmit, control, errors, reset } = useCustomReactHookForm({
    formDefaultValue: sortDefaultValue,
    formSchema: sortSchema,
  });

  const openSidebar = () => setIsOpen(true);

  const onSubmit = (data: TSort) => {
    const sortQuery = buildSortQuery(data.sortField, data.sortOrder);
    const params = new URLSearchParams(searchParams.toString());

    if (sortQuery) params.set("sort", sortQuery);
    else params.delete("sort");

    router.push(`${pathname}?${params.toString()}`);
    setIsOpen(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BiSort
        title={t("Sort")}
        aria-label={t("Sort")}
        size={25}
        onClick={openSidebar}
        className="text-foreground-muted cursor-pointer hover:text-primary transition-all duration-200"
      />

      {isOpen && (
        <MainSidebar setIsOpen={setIsOpen} isOpen={isOpen} reset={reset}>
          <GlobalPageSortSidebar control={control} errors={errors} />
        </MainSidebar>
      )}
    </form>
  );
};

export default GlobalPageSort;
